module.exports = __webpack_public_path__ + "img/bb01.ce7ae4ba.png";